import React, { CSSProperties } from 'react';

import { PopupMenu } from './PopupMenu';
import {
  Asset,
  AssetId,
  AGGREGATE_SOURCE,
  AggregateSource,
} from 'hooks/useGrouping';
import { Group, GroupId } from 'hooks/useGrouping';
import { formatNumber } from 'utils/formatter';
import { StopAggregate } from 'components/features/home/PortfolioStuffing/asset/AssetOrganizedPortfolioForeign';

type AssetItemProps = {
  className?: string;
  style?: CSSProperties;
  asset: Asset;
  groups: Group[];
  changeGroup: (groupId: GroupId) => Promise<void>;
  showPopupMenu: boolean;
  setShowPopupMenuAssetId: (assetId: AssetId | null) => void;
  select:
    | {
        isSelect: true;
        selected: boolean;
        toggleSelect: (event: React.MouseEvent) => void;
      }
    | { isSelect: false };
};

const AssetItem: React.FC<AssetItemProps> = props => {
  const getTallyTargetMessage = (isTallyTarget: boolean): string => {
    return isTallyTarget ? '集計対象' : '集計対象外';
  };
  const getServiceName = (service: AggregateSource): string => {
    return Object.keys(AGGREGATE_SOURCE).filter(
      key => AGGREGATE_SOURCE[key] === service
    )[0];
  };

  const itemClickHandler = (event: React.MouseEvent): void => {
    if (props.select.isSelect) props.select.toggleSelect(event);
  };

  const showPopupMenu = (): void =>
    props.setShowPopupMenuAssetId(props.asset.id);

  const popupMenuTitle = `${
    (props.asset.brokerName ?? '').length > 5
      ? `${(props.asset.brokerName ?? '').slice(0, 5)}…`
      : props.asset.brokerName ?? ''
  }を`;

  const checkIconClass = `icon-check ${
    props.select.isSelect && props.select.selected ? 'is-active' : ''
  }`;

  const formattedTotalAssetAmount = `${
    props.asset.totalAssetAmount !== '---'
      ? formatNumber(props.asset.totalAssetAmount, {})
      : props.asset.totalAssetAmount
  }円`;

  return (
    <li
      className={`asset-list-item  ${props.className ? props.className : ''} ${
        props.select.isSelect ? 'cursor-pointer' : ''
      }`}
      style={props.style}
      onClick={itemClickHandler}>
      <div className="check-col" onClick={itemClickHandler}>
        <i onClick={itemClickHandler} className={checkIconClass}></i>
      </div>
      <div className={`asset-list-item-contents`}>
        {props.asset.refresh && (
          <StopAggregate {...{ refresh: props.asset.refresh }} />
        )}
        <div className="asset-list-item-primary-row">
          <div className="asset-list-item-label">{props.asset.brokerName}</div>
          <div className="asset-list-item-value">
            {formattedTotalAssetAmount}
          </div>
        </div>
        <div className="asset-list-item-secondary-row">
          <div className="asset-list-item-secondary-label flex flex-row">
            <div className="">
              {getServiceName(props.asset.aggregateSource)}
            </div>
          </div>
          <div
            className={
              'asset-list-item-secondary-status-label' +
              (props.asset.isTallyTarget ? ' is-target' : '')
            }>
            {getTallyTargetMessage(props.asset.isTallyTarget)}
          </div>
        </div>
      </div>
      <div className="asset-item-navigate">
        <i className="icon-more-vertical" onClick={showPopupMenu}></i>
        <PopupMenu
          title={popupMenuTitle}
          groups={props.groups}
          changeGroup={props.changeGroup}
          asset={props.asset}
          showPopupMenu={props.showPopupMenu}
          closeHandlers={{
            onClose: (): void => props.setShowPopupMenuAssetId(null),
            shouldClosePopupMenuFromPoint: (_): boolean => true,
          }}
        />
      </div>
    </li>
  );
};

export default AssetItem;
